<template>
	<!-- empty -->
	<div></div>
</template>

<script>
export default {
	name: 'home',
	data() {
		return {};
	}
};
</script>

<style lang="less" scoped></style>
